import PropTypes from "prop-types"

const stripBrand = value =>
  String(value || "")
    .replace(/^\s*(amok(?:\.earth)?|amok\s*\.?\s*earth)\s*[-|:–—]?\s*/i, "")
    .trim()

const Message = ({ notification }) => {
  const title = stripBrand(notification?.title) || "New notification"

  return (
    <div className="push-toast">
      <p className="push-toast__title">{title}</p>
    </div>
  )
}

Message.propTypes = {
  notification: PropTypes.shape({
    title: PropTypes.string,
  }),
}

export default Message
